import {Layout} from '../../src/Layout';
export default Layout;

import {Switch} from '@react-spectrum/s2';
import docs from 'docs:@react-spectrum/s2';

export const tags = ['toggle', 'input'];
export const description = 'Allows a user to turn a setting on or off.';

# Switch

<PageDescription>{docs.exports.Switch.description}</PageDescription>

<VisualExample
  component={Switch}
  docs={docs.exports.Switch}
  props={['children', 'size', 'description', 'isEmphasized', 'isDisabled']}
  initialProps={{
    children: 'Low power mode'
  }}
  importSource="@react-spectrum/s2/Switch"
  type="s2" />

## Selection

Use the `isSelected` or `defaultSelected` prop to set the selection state, and `onChange` to handle selection changes.

```tsx render
"use client";
import {Switch} from '@react-spectrum/s2/Switch';
import {useState} from 'react';

function Example(props) {
  let [selected, setSelection] = useState(false);

  return (
    <>
      <Switch 
        {...props}
        ///- begin highlight -///
        isSelected={selected}
        onChange={setSelection}
        ///- end highlight -///
      >
        Low power mode
      </Switch>
      <p>{selected ? 'Low' : 'High'} power mode active.</p>
    </>
  );
}
```

## Forms

Use the `name` and `value` props to submit the switch to the server. Set the `isRequired` prop to validate the user selects the switch, or implement custom client or server-side validation. See the [Forms](forms) guide to learn more.

```tsx render
"use client";
import {Switch} from '@react-spectrum/s2/Switch';
import {Button} from '@react-spectrum/s2/Button';
import {Form} from '@react-spectrum/s2/Form';

<Form>
  {/*- begin highlight -*/}
  <Switch
    name="two-factor"
    isRequired
    description="Your organization requires two-factor authentication.">
    Two-factor authentication
  </Switch>
  {/*- end highlight -*/}
  <Button type="submit">Submit</Button>
</Form>
```

## API

<PropTable component={docs.exports.Switch} links={docs.links} />
